import AITool from "@/app/components/atomic/molecules/AITool";
import React from "react";

interface AIToolEmbedProps {
    toolFileName: string;
    prerenderFileName: string;
}

export const AI_EMBED_BASE = 'https://guide.reassurez-moi.fr/guide/wp-content/uploads/ai-tools/';

const AIToolEmbed: React.FC<AIToolEmbedProps> = ({ toolFileName, prerenderFileName }) => {
   // const prerender = fetch(`${AI_EMBED_BASE}${prerenderFileName}.html`).then((response) => response.text())
    return (
        <AITool toolFileName={toolFileName}>
            <div className="ai-tool-container flex justify-center items-center bg-blue-100 p-4 py-10 rounded-lg text-blue-700">
                Chargement de l'outil en cours...
            </div>
        </AITool>
    );
};

export default AIToolEmbed;
